import { Navigate, Outlet } from 'react-router-dom';

const PublicRoute = () => {
  const accessToken = sessionStorage.getItem("token"); // Check for access token

  // If the user is authenticated, redirect to the dashboard
  if (accessToken) {
    return <Navigate to="/" />;
  }

  // Otherwise, render the requested component
  return <Outlet />;
};

export default PublicRoute;
